import React from 'react';
import { Link, useHistory } from 'react-router-dom';
import {
  Form, FormikProvider, useFormik,
} from 'formik';
import { Layout } from 'antd';
import { Location } from 'history';
import { useActions } from '../../providers/actions-provider/actions.context';
import { FORGOT_PASSWORD_PATH, FORGOT_USERNAME_PATH } from '../../routing/paths.constants';
import FormControl from '../../lib/form-control';
import { SignInRequestDTO } from '../../../store/modules/user/dto/sign-in.dto';
import { createValidator } from '../../../utils/create-validator';
import LogoButton from '../../lib/logo-button';
import { useStore } from '../../../store';

interface ISignInProps {
  redirectLocation: Location | null;
  setRedirectLocation: (location: Location | null) => void;
}

const SignIn = ({ redirectLocation, setRedirectLocation }: ISignInProps): JSX.Element => {
  const state = useStore();
  const authTypeInfo = state.authType.data;
  const isOauth2 = authTypeInfo?.auth_type === 'OAUTH2';
  const isOpenID = authTypeInfo?.auth_type === 'OPENID';

  const history = useHistory();
  const { userActions } = useActions();
  const formik = useFormik({
    initialValues: {
      username: '',
      password: '',
    },
    onSubmit: async (values) => {
      const success = await userActions.signIn(values);
      if (success && redirectLocation) {
        setRedirectLocation(null);
        history.replace(redirectLocation);
      }
    },
    validate: (values: SignInRequestDTO) => createValidator(SignInRequestDTO, values),
  });

  if (isOauth2 || isOpenID) {
    return (
      <Layout className="auth-layout auth-layout__sign-in">
        <div className="form">
          <LogoButton disabled />
          <h2 className="auth-layout__form-title">Welcome</h2>
          <button
            type="button"
            className="auth-layout__form-submit"
            onClick={() => {
              const apiHost = process.env.REACT_APP_API_HOST || '';
              const { timeZone } = Intl.DateTimeFormat().resolvedOptions();
              window.location.href = `${apiHost}/user-manager/api/login?timeZone=${encodeURIComponent(timeZone)}`;
            }}
          >
            Log in
          </button>

          <button
            type="button"
            className="auth-layout__form-submit"
            onClick={() => {
              const apiHost = process.env.REACT_APP_API_HOST || '';
              window.location.href = `${apiHost}/user-manager/api/logout`;
            }}
          >
            Log out
          </button>
        </div>
      </Layout>
    );
  }

  return (
    <Layout className="auth-layout auth-layout__sign-in">
      <div className="form">
        <LogoButton disabled />
        <FormikProvider value={formik}>
          <Form className="auth-layout__form">
            <h2 className="auth-layout__form-title">Welcome</h2>
            <FormControl name="username" label="Login" type="text" inputClassName="form__input auth" wrapperClassName="form__label" />
            <FormControl name="password" label="Password" type="password" inputClassName="form__input" wrapperClassName="form__label" />
            <button type="submit" className="auth-layout__form-submit">
              Log in
            </button>
            <div className="auth-layout__forgot-password">
              <Link to={FORGOT_PASSWORD_PATH}>Forgot password?</Link>
              <span style={{ color: '#fff', padding: '10px' }}>|</span>
              <Link to={FORGOT_USERNAME_PATH}>Forgot username?</Link>
            </div>
          </Form>
        </FormikProvider>
      </div>

    </Layout>
  );
};

SignIn.displayName = 'SignIn';

export default SignIn;
